import { type FC, useState } from "react";
import { useApi } from "../api/APIContext";
import { useApiCall, ValidationError } from "../api/api";
import { Autocomplete } from "../components/form/Autocomplete";
import { Input } from "../components/form/Input";
import { ModalFooter } from "../components/layout/ModalProvider";
import { useRefresh } from "../components/RefreshController";

export const AddAssessorModal: FC<{}> = (props) => {
  const { addAssessor } = useApiCall();
  const refresh = useRefresh();
  const [firstName, setFirstName] = useState<string>("");
  const [lastName, setLastName] = useState<string>("");
  const [company, setCompany] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [phone, setPhone] = useState<string>("");
  const [errors, setErrors] = useState<string[]>([]);

  const save = async () => {
    await addAssessor(
      firstName,
      lastName,
      company.trim().length === 0 ? null : company.trim(),
      email.trim().length === 0 ? null : email.trim(),
      phone.trim().length === 0 ? null : phone.trim(),
    ).catch((e) => {
      if (e instanceof ValidationError) {
        setErrors(Object.values(e.errors).flat());
      }
      throw e;
    });
    refresh();
  };
  return (
    <div className={""}>
      <div className={"uppercase text-xs text-slate-500"}>Naam (verplicht)</div>
      <div className={"grid grid-cols-2 gap-3 border border-slate-200 rounded-sm px-2 py-2"}>
        <Input type={"text"} label={"Voornaam"} value={firstName} onChange={setFirstName} />
        <Input type={"text"} label={"Achternaam"} value={lastName} onChange={setLastName} />
      </div>
      <div className={"uppercase text-xs text-slate-500 mt-3"}>Contactgegevens (optioneel)</div>
      <div className={"grid grid-cols-1 gap-3 border border-slate-200 rounded-sm px-2 py-2"}>
        <Input type={"text"} label={"Bedrijf"} value={company} onChange={setCompany} />
        <Input type={"text"} label={"E-mail"} value={email} onChange={setEmail} />
        <Input type={"text"} label={"Telefoon"} value={phone} onChange={setPhone} />
      </div>
      <ModalFooter
        text={"Opslaan"}
        disabled={firstName.trim().length === 0 || lastName.trim().length === 0}
        onSubmit={save}
      />
    </div>
  );
};
